/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {WizardStepModel} from './wizard-step.model';

@Injectable()
export class WizardService {
    subject = new Subject<WizardStepModel>();
    observable = this.subject.asObservable();

    private _steps: Map<number, WizardStepModel> = new Map();

    get steps(): Map<number, WizardStepModel> {
        return this._steps;
    }

    get isTouched(): boolean {
        let isTouched = false;

        this._steps.forEach(step => {
            isTouched = isTouched || step.isTouched;
        });

        return isTouched;
    }

    get isEmpty(): boolean {
        let isEmpty = true;

        this._steps.forEach(step => {
            isEmpty = isEmpty && step.isEmpty;
        });

        return isEmpty;
    }

    get canSave(): boolean {
        let canSave = true;

        this._steps.forEach(step => {
            canSave = canSave && step.canSave;
        });

        return canSave;
    }

    get canSend(): boolean {
        let canSend = true;

        this._steps.forEach(step => {
            canSend = canSend && step.canSend;
        });

        return canSend;
    }

    updateStep(step: WizardStepModel): void {
        this._steps.set(step.index, step);
        this.subject.next(step);
    }
}

